import getUtilityClassName from './getUtilityClassName';
import getStateClassName from './getStateClassName';
import getComponentModifierClassName from './getComponentModifierClassName';
import getComponentClassName from './getComponentClassName';
import getAsArray from '../getAsArray';
import { TBoxAugments } from '../../types/TBoxAugments';

type TGetClassNames = {
  name: string;
};

const getClassNames = ({
  name,
  parent,
  states,
  modifiers,
  utilities,
  custom,
}: TGetClassNames & TBoxAugments): string => {
  const getModifierClassName = (modifier) => getComponentModifierClassName({ name, parent, modifier });
  return [
    getComponentClassName(name, parent),
    modifiers && getAsArray(modifiers).map(getModifierClassName).join(' '),
    states && getAsArray(states).map(getStateClassName).join(' '),
    utilities && getAsArray(utilities).map(getUtilityClassName).join(' '),
    custom,
  ]
    .filter(Boolean)
    .join(' ');
};

export default getClassNames;

export const cn = (name: string, other?: TBoxAugments) => getClassNames({ name, ...other });
